/**
 * quarterlyPrereadOverride — short-lived shield around
 * meta.quarterlyPreread so the 60s meta refetch (or KV's per-region
 * read cache) can't briefly revert a save Zoe just made.
 *
 * Same pattern as execSummaryOverride / companyUpdateOverride.
 */

const OVERRIDE_TTL_MS = 15_000

let override = null // { value, at } | null

export function rememberQuarterlyPreread(value) {
  override = { value, at: Date.now() }
  setTimeout(() => {
    if (override && Date.now() - override.at >= OVERRIDE_TTL_MS) {
      override = null
    }
  }, OVERRIDE_TTL_MS + 100)
}

export function getQuarterlyPrereadOverride() {
  if (!override) return undefined
  if (
    !Number.isFinite(override.at) ||
    Date.now() - override.at >= OVERRIDE_TTL_MS
  ) {
    override = null
    return undefined
  }
  return override.value
}

export function clearQuarterlyPrereadOverride() {
  override = null
}
